import React from 'react'
import { InboxType } from '../../../../server/models/Inbox'
import { useInboxPublicationsQuery } from '../../../requests/inboxes'
import { Skeleton } from '../../../components/Skeleton'

type Props = {
  inbox: InboxType
}

export const InboxPublicationsList: React.FC<Props> = ({ inbox }) => {
  const { data: publications = [], isLoading: loading } = useInboxPublicationsQuery(
    inbox._id || '',
    {
      enabled: !!inbox._id,
    }
  )

  if (loading) {
    return <Skeleton width={150} />
  }

  if (!publications.length) {
    return <span>No publications</span>
  }

  return (
    <span>
      {publications.join(', ')}
    </span>
  )
}
